// Singleton-ish composable for the learner-me payload (XP, streak, badges).
// One ref shared across components; refresh() forces a re-fetch.

import { ref } from 'vue'

import { apiRequest, ApiError } from '@/api/client'

export interface BadgeEarned {
  id: string
  slug: string
  name: string
  description: string
  icon: string
  tier: string
  xp_reward: number
}

export interface MeState {
  xp_total: number
  xp_today: number
  streak_current: number
  streak_longest: number
  badge_count: number
  recent_badges: BadgeEarned[]
}

const state = ref<MeState | null>(null)
const loading = ref(false)
const error = ref<string | null>(null)

async function refresh(): Promise<void> {
  loading.value = true
  error.value = null
  try {
    state.value = await apiRequest<MeState>('/v1/learn/me')
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) {
      state.value = null
      return
    }
    error.value = err instanceof ApiError ? err.message : 'Could not load your profile'
  } finally {
    loading.value = false
  }
}

function reset(): void {
  state.value = null
}

export function useLearnerMe() {
  return { state, loading, error, refresh, reset }
}
